<script>
  import { windowsForApp } from '../os/windows.svelte.js';

  let { contextMenu = null, isRunning = () => false, onaction = () => {} } = $props();
  let menuEl = $state(null);

  function handleKeydown(event) {
    const buttons = menuEl?.querySelectorAll('button');
    if (!buttons?.length) return;
    const current = Array.from(buttons).indexOf(document.activeElement);
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const next = (current + 1) % buttons.length;
      buttons[next]?.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prev = (current - 1 + buttons.length) % buttons.length;
      buttons[prev]?.focus();
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      document.activeElement?.click();
    } else if (event.key === 'Escape') {
      onaction('close');
    }
  }
</script>

{#if contextMenu}
  <div
    class="dock-context-menu"
    bind:this={menuEl}
    style={`left:${contextMenu.x}px;top:${contextMenu.y}px`}
    role="menu"
    tabindex="-1"
    onpointerdown={(event) => event.stopPropagation()}
    onkeydown={handleKeydown}
  >
    <strong>{contextMenu.app.label}</strong>
    {#each windowsForApp(contextMenu.app.id) as win (win.id)}
      <button onclick={() => onaction('window', win.id)}>
        <span class:context-window-active={!win.minimized}>✓</span>
        <span>{win.title}</span>
      </button>
    {/each}
    {#if windowsForApp(contextMenu.app.id).length}
      <span class="dock-context-separator"></span>
    {/if}
    <button onclick={() => onaction('new')}>New Window</button>
    {#if isRunning(contextMenu.app.id)}
      <button onclick={() => onaction('show')}>Show All Windows</button>
      <button onclick={() => onaction('hide')}>Hide</button>
      <span class="dock-context-separator"></span>
      <button onclick={() => onaction('quit')}>Quit</button>
    {/if}
  </div>
{/if}

<style>
  .dock-context-menu {
    position: fixed;
    z-index: 10000020;
    display: grid;
    min-width: 196px;
    padding: 5px 0;
    color: #edf0f0;
    background:
      repeating-linear-gradient(0deg, rgba(255,255,255,.025) 0 1px, rgba(0,0,0,.035) 1px 2px),
      rgba(39,42,42,.98);
    border: 1px solid #101212;
    border-radius: 4px;
    box-shadow: inset 0 1px rgba(255,255,255,.13), 0 10px 28px rgba(0,0,0,.62);
  }
  .dock-context-menu strong {
    padding: 4px 18px 5px;
    color: #fff;
    font: 700 12px var(--font);
  }
  .dock-context-menu button {
    display: grid;
    grid-template-columns: 15px 1fr;
    width: 100%;
    min-height: 22px;
    padding: 2px 18px 2px 8px;
    color: inherit;
    font: 12px var(--font);
    text-align: left;
    background: transparent;
    border: 0;
  }
  .dock-context-menu button:hover {
    background: linear-gradient(var(--graphite-select-top), var(--graphite-select-bot));
  }
  .dock-context-menu button:not(:has(.context-window-active)) {
    grid-template-columns: 1fr;
    padding-left: 23px;
  }
  .dock-context-menu .context-window-active { color: var(--graphite-focus); }
  .dock-context-separator {
    height: 1px;
    margin: 3px 1px;
    background: #151717;
    border-bottom: 1px solid #555b5b;
  }
</style>
